import React from "react";
import SimpleChannelTestPage from "./SimpleChannelTestPage";

export const TelegramTestPage: React.FC = () => (
  <SimpleChannelTestPage channel="telegram" />
);

export default TelegramTestPage;
